import React from 'react'

function NutIcon(props) {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="15.521"
         height="15.521"
         viewBox="0 0 15.521 15.521"
      >
         <path
            fill={props.color}
            id="NutIcon"
            d="M85.975,191.521l-.388-2.444a5.2,5.2,0,0,1-.776-.369,5.331,5.331,0,0,1-.718-.485L81.8,189.27,80,186.088l2.1-1.533a2.307,2.307,0,0,1-.048-.4q-.01-.223-.01-.4t.01-.4a2.307,2.307,0,0,1,.048-.4L80,181.432l1.8-3.182,2.289,1.048a5.331,5.331,0,0,1,.718-.485,4.015,4.015,0,0,1,.776-.349L85.975,176h3.57l.388,2.444a6.288,6.288,0,0,1,.786.359,3.339,3.339,0,0,1,.708.495l2.289-1.048,1.8,3.182-2.1,1.494a2.734,2.734,0,0,1,.049.417q.01.223.01.417t-.01.407a2.7,2.7,0,0,1-.049.407l2.1,1.513-1.8,3.182-2.289-1.048a6.435,6.435,0,0,1-.708.495,3.38,3.38,0,0,1-.786.359l-.388,2.444Zm1.785-5.238a2.517,2.517,0,1,0-1.785-.737A2.431,2.431,0,0,0,87.76,186.282Zm0-1.164a1.358,1.358,0,1,1,.96-.4A1.308,1.308,0,0,1,87.76,185.118ZM87.76,183.76Zm-.854,6.6h1.707l.272-2.173A4.575,4.575,0,0,0,90.1,187.7a4.973,4.973,0,0,0,1.038-.8l2.056.892.776-1.4-1.824-1.339q.078-.33.126-.65a4.333,4.333,0,0,0,.048-.65,5.4,5.4,0,0,0-.039-.65,4.014,4.014,0,0,0-.136-.65l1.824-1.339-.776-1.4-2.056.892a4.324,4.324,0,0,0-1.009-.844,3.272,3.272,0,0,0-1.242-.437l-.272-2.173H86.907l-.272,2.173a4.11,4.11,0,0,0-1.232.466,4.279,4.279,0,0,0-1.019.815l-2.056-.892-.776,1.4,1.824,1.339q-.078.33-.126.65a4.379,4.379,0,0,0,0,1.3q.049.32.126.65L81.552,186.4l.776,1.4,2.056-.892a4.973,4.973,0,0,0,1.038.8,4.575,4.575,0,0,0,1.213.485Z"
            transform="translate(-80 -176)"
         />
      </svg>
   )
}

export default NutIcon
